import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'rc-time-picker/assets/index.css';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import TimePicker from 'rc-time-picker';
import { Icon } from 'semantic-ui-react';

import * as cm_action from 'actions/commons';

import toastr from 'helpers/toastr';

class HourPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start: moment().hour(0),
      end: moment().hour(0)
    };
  }

  componentWillMount() {
    const now = moment().hour(0);

    this.handleChange('sTime', now);
    this.handleChange('eTime', now);
  }

  onChange = (time, type) => {
    const { hour } = this.props;

    if (type === 'sTime' && time.format('HH') > hour.eTime) {
      toastr('top-right', 'warning', '시작시각을 종료시각 이전으로 선택해주세요.');
    } else if (type === 'eTime' && time.format('HH') < hour.sTime) {
      toastr('top-right', 'warning', '종료시각을 시작시각 이후로 선택해주세요.');
    } else {
      this.handleChange(type, time);
    }
  };

  handleChange = async (type, value) => {
    const { commonFn } = this.props;
    await commonFn.changeTime({
      type: 'hour',
      name: type,
      value: value.format('HH')
    });

    const { hour } = this.props;
    this.setState({
      start: moment().hour(parseInt(hour.sTime)),
      end: moment().hour(parseInt(hour.eTime))
    });
  };

  render() {
    const { hour } = this.props,
      { start, end } = this.state;

    return (
      <div className="form-hourpicker">
        <Icon.Group className="cm-time hour-picker">
          <Icon bordered name="wait" />
          <TimePicker
            defaultValue={moment(new Date(start))}
            defaultOpenValue={moment(new Date(start))}
            onChange={(e) => this.onChange(e, 'sTime')}
            //disabled={isDim}
            showMinute={false}
            showSecond={false}
            popupClassName="TimePop"
            value={start}
          />
        </Icon.Group>
        <Icon name="minus" className="timepicker-bar" />
        <Icon.Group className="cm-time hour-picker">
          <Icon bordered name="wait" />
          <TimePicker
            defaultValue={moment(new Date(end))}
            defaultOpenValue={moment(new Date(end))}
            onChange={(e) => this.onChange(e, 'eTime')}
            //disabled={isDim}
            showMinute={false}
            showSecond={false}
            popupClassName="TimePop"
            value={end}
          />
        </Icon.Group>
      </div>
    );
  }
}

HourPicker = connect(
  (state) => ({
    hour: state.commons.hour
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeTime: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(HourPicker);

export default HourPicker;
